/**
 * BottomBackgroundMask component
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Bottom background mask (dark fade).
 */

const Mask = styled.div`
  background: linear-gradient(179deg, rgba(0, 0, 0, 0) 22.23%, #000 57.84%);
  top: 0;
  height: ${1080 * Screen.widthRatio}px;
  left: ${801 * Screen.widthRatio}px;
  position: fixed;
  width: ${1200 * Screen.widthRatio}px;
  z-index: 1;
`;

/**
 * Props for the bottom background mask.
 */
interface Props {
  miniDetailFocused: boolean;
}

/**
 * Renders the bottom background mask only while the mini detail (description) panel is focused.
 */
export default function BottomBackgroundMask({ miniDetailFocused }: Props) {
  if (!miniDetailFocused) return null;

  return <Mask />;
}
